import { observer } from "mobx-react-lite";
import { appRoutes } from "@/app/router";
import { FC, useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { usePublicAppStore } from "@/store";
import { AuthCardLogIn } from "@/components/auth";
import { EXTENSION_CLOSE_WINDOW_COOKIE_NAME } from "@/domains/extension";
import Cookies from "js-cookie";
import { AuthLayout } from "@/components/auth/layout/AuthLayout";

export const LogInPage: FC = observer(() => {
  const { publicStore } = usePublicAppStore();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const referrer = searchParams.get("referrer");

    if (referrer === "chrome-extension") {
      // Set cookie to indicate window should close after authentication
      // This is used when the Chrome extension opens a popup window for auth.
      // After successful login, the window will detect this cookie and auto-close,
      // returning control to the extension.
      // Not used in standard flow (it wont have referrer query)
      Cookies.set(EXTENSION_CLOSE_WINDOW_COOKIE_NAME, "true", {
        path: "/",
        secure: true,
        sameSite: "strict",
        // Short expiry - only needed during auth flow
        expires: 1 / 24, // 1 hour
      });
    }
  }, [searchParams]);

  if (publicStore.auth.isAuthenticated) {
    return <Navigate to={appRoutes.notesList({}).path} />;
  }

  return (
    <AuthLayout>
      <AuthCardLogIn />
    </AuthLayout>
  );
});
